export function getNodeServerUri(path) {
    return `http://localhost:6051/${path}`;
}

export function getNonApiUri(path) {
    return `${window.rootUrl}${path}`;
}

export function getApiUri(path) {
    return `${window.rootUrl}api/${path}`;
}
